import { atom } from "recoil";

// sign in 시 확인한 이메일 인증 여부 state
const emailVarified = atom({
  key: "emailVarified",
  default: false,
});

export { emailVarified };
